export const CURRENT_ORDER_ID_STORAGE = 'orderID';
export const ORDER_TRACKING_CONVERSION_STORAGE = 'gtm-datalayer-order';
